class Auth {
  constructor() {
    this.authenticated = false;
  }

  signIn(cb) {
    this.authenticated = true;
    cb();
  }

  signOut(cb) {
    this.authenticated = false;
    cb();
  }

  isAuthenticated() {
    if (localStorage.getItem('token') && localStorage.getItem('user')) {
      this.authenticated = true;
      return this.authenticated;
    } else {
      return false;
    }
  }

  getUser() {
    return JSON.parse(localStorage.getItem('user'));
  }
}

export default new Auth();
